import { CssBaseline, ThemeProvider } from '@mui/material';
import { theme } from '@mightyhive/theme';
import { AnalyticsProvider } from '@mightyhive/analytics';
import { PostAnalysis } from '@mightyhive/postanalysis';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { UserProvider } from './context/UserContext';
import { Layout } from './layout/Layout';
import { Clients } from './routes/Clients';
import { DataSources } from './routes/DataSources';
import { Hype } from './routes/Hype';
import { Grid } from './routes/Grid';
import { Home } from './routes/Home';
import { Library } from './routes/Library';
import { LibraryDetail } from './routes/LibraryDetail';
import { RouteLocations } from './routes/RouteLocations';
import { SplashLogin } from './routes/SplashLogin';
import { ANALYTICS_ENABLED } from './utils/analytics';
import { useUser } from './context/UserContext';
import { HypeProvider } from './context/HypeContext';

function PostAnalysisWithClient(): JSX.Element {
  const { selectedClientExternalUuid } = useUser();

  return <PostAnalysis selectedClientExternalUuid={selectedClientExternalUuid} />;
}


function App(): JSX.Element {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AnalyticsProvider enabled={ANALYTICS_ENABLED}>
      
        <BrowserRouter>
          <Routes>
            {/* Public splash login — no UserProvider/Layout wrapper */}
            <Route path="login" element={<SplashLogin />} />

            {/* Authenticated app shell */}
            <Route
              element={
                <UserProvider>
                  <HypeProvider>
                    <Layout />
                  </HypeProvider>
                </UserProvider>
              }
            >
              <Route index element={<Navigate to={RouteLocations.HOME} replace />} />
              <Route path={RouteLocations.HOME} element={<Home />} />
              <Route path={RouteLocations.EXPERIMENTS} element={<Navigate to={RouteLocations.LIBRARY} replace />} />
              <Route path={RouteLocations.CLIENTS} element={<Clients />} />
              <Route path={RouteLocations.LIBRARY} element={<Library />} />
              <Route path={`${RouteLocations.LIBRARY}/:externalUuid`} element={<LibraryDetail />} />
              <Route path={`${RouteLocations.GRID}/*`} element={<Grid />} />
              <Route path={RouteLocations.DATA_SOURCES} element={<DataSources />} />
              <Route path={RouteLocations.HYPE} element={<Hype />} />
              <Route path={`${RouteLocations.ANALYSIS}/*`} element={<PostAnalysisWithClient />} />
            </Route>
          </Routes>
        </BrowserRouter>

      </AnalyticsProvider>
    </ThemeProvider>
  );
}

export default App;
